import { render, staticRenderFns } from "./RemoteServiceList.vue?vue&type=template&id=446fb3a9&"
import script from "./RemoteServiceList.vue?vue&type=script&lang=js&"
export * from "./RemoteServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports